var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('a',_vm._b({attrs:{"href":_vm.to}},'a',_vm.$attrs,false),[_vm._t("default")],2):_c('router-link',_vm._b({},'router-link',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }